export default "__VITE_ASSET__835cc2c8__"